import { CreateCashierShiftDto } from "./../../../dtos/catalogs/CashierShift/CreateCashierShiftDto";
import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { CashierShiftDetail } from "../../../components/Pages/Catalogs/CashierShift/CashierShiftDetail";
import CashierShiftList from "../../../components/Pages/Catalogs/CashierShift/CashierShiftList";
import { NFLookupCashierShift } from "../../../components/Shared/NewForms/NFLookupCashierShift";
import { CashierShiftService } from "../../../services/catalogs/CashierShiftService";

export const CashierShift: IAppEntity = {
  entityType: "catalog",
  title: "Cashier Shift",
  pluralTitle: "Cashier Shifts",
  apiUrl: "CashierShifts",
  apiEnum: ReferenceTypes.CatalogCashierShift,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(CashierShiftDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(CashierShiftList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupCashierShift, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new CashierShiftService(this.apiUrl);
  },
  getEmptyModel(): CreateCashierShiftDto {
    return {
      name: "",
      createdDate: new Date(),
      cashShiftStart: new Date(),
      cashShiftEnd: new Date(),
    };
  },
};
